import React from "react";
import { splitOrderTaxes } from "../utils/splitOrderTaxes";

export default function OrderTaxRows({ summary }) {
  const { totalTax, bizzllFee } = splitOrderTaxes(summary);
  const format = (amount) => amount === null ? "Unavailable" : `$${amount.toFixed(2)}`;
  return (
    <div className="order-tax-rows">
      <div className="summary-row" style={{ display: "flex", justifyContent: "space-between", gap: 16, padding: "8px 0" }}>
        <span className="label">Total Tax</span>
        <span className="value">{format(totalTax)}</span>
      </div>
      <div className="summary-row" style={{ display: "flex", justifyContent: "space-between", gap: 16, padding: "8px 0" }}>
        <span className="label">Bizzll Fee (10%)</span>
        <span className="value">{format(bizzllFee)}</span>
      </div>
    </div>
  );
}
